import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Permissions = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:role",
    read: "read:role",
    list: "list:role",
    delete: "delete:role",
    update: "update:role",
  },
};
